import { environment } from '../../../environments/environment';

const LOCALHOST_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

/** Normalize user input to a bare hostname (lowercase, no scheme/path/port). */
export function normalizeCustomDomainHostname(raw: string): string | null {
  let value = raw.trim().toLowerCase();
  if (!value) {
    return null;
  }

  if (value.includes('://')) {
    try {
      value = new URL(value).hostname.toLowerCase();
    } catch {
      return null;
    }
  } else {
    value = value.split('/')[0]?.split(':')[0]?.replace(/\.$/, '') ?? '';
  }

  if (!value || value.includes(' ')) {
    return null;
  }

  if (!/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i.test(value)) {
    return null;
  }

  return value;
}

export function getDefaultAppHostname(): string {
  try {
    return new URL(environment.appUrl).hostname.toLowerCase();
  } catch {
    return 'localhost';
  }
}

export function getCustomDomainCnameTarget(): string {
  const configured = environment.customDomainCnameTarget?.trim();
  if (configured) {
    return configured.toLowerCase();
  }
  return getDefaultAppHostname();
}

export function isDefaultAppHostname(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  if (LOCALHOST_HOSTS.has(host)) {
    return true;
  }
  return host === getDefaultAppHostname();
}

export function isReservedCustomDomainHostname(hostname: string): boolean {
  const normalized = normalizeCustomDomainHostname(hostname);
  if (!normalized) {
    return true;
  }
  if (LOCALHOST_HOSTS.has(normalized)) {
    return true;
  }
  if (normalized === getDefaultAppHostname()) {
    return true;
  }
  return false;
}

export function customDomainTxtRecordName(hostname: string): string {
  return `_finder-verify.${hostname}`;
}
